define('views/shared/alerts/alert',[
	"backbone",
	"views/_base/baseview",
	"text!views/shared/alerts/alert.html",
	"views/shared/alerts/action_alert",
], function (Backbone, BaseView, Template, ActionAlertView) {
	"use strict";

	return BaseView.extend({
		className: "alert-container",
		tagName: "div",
		isRender: true,
		needsAuth: false,
		template: _.template(Template),
		events: {
			"click .js-alert-cancel": "cancelProcessMODAL",
			"click .js-alert-acknowledge-btn": "startProcessMODAL",
		},
		initialize: function (options) {
			var options = options || {};

			// External Configuration Options

			// General
			this.calling_view = options.calling_view;
			this.alert_type = options.alert_type >= 0 ? options.alert_type : 0; // 0 - Standard, 1 - Action

			// Transactional
			this.is_transaction = options.is_transaction;
			this.transaction_callback = options.transaction_callback ? options.transaction_callback : null;

			// Content
			this.alert_header = options.alert_header ? options.alert_header : "";
			this.alert_content_header = options.alert_content_header ? options.alert_content_header : "";
			this.alert_message_icon = options.alert_message_icon ? options.alert_message_icon : "";
			this.alert_message = options.alert_message ? options.alert_message : "";

			// Defaults
			this.btn_label = options.btn_label ? options.btn_label : "Save";
			this.btn_color = options.btn_color ? options.btn_color : "";
			this.btn_callback = options.btn_callback ? options.btn_callback : null;
			this.btn_retry_callback = options.btn_retry_callback ? options.btn_retry_callback : null;

			// Confirm
			this.btn_confirm = options.btn_confirm;
			this.btn_confirm_amount = options.btn_confirm_amount ? options.btn_confirm_amount : 0;
			this.btn_confirm_label = options.btn_confirm_label ? options.btn_confirm_label : "Confirm";
			this.btn_confirm_callback = options.btn_confirm_callback ? options.btn_confirm_callback : null;

			// Cancel
			this.btn_cancel = options.btn_cancel;
			this.btn_cancel_label = options.btn_cancel_label ? options.btn_cancel_label : "Cancel";
			this.btn_cancel_callback = options.btn_cancel_callback ? options.btn_cancel_callback : null;

			// Success
			this.btn_success = options.btn_success;
			this.btn_success_delay = options.btn_success_delay ? options.btn_success_delay : 1500;
			this.btn_success_label = options.btn_success_label ? options.btn_success_label : "Success";
			this.btn_success_message = options.btn_success_message ? options.btn_success_message : "";
			this.btn_success_callback = options.btn_success_callback ? options.btn_success_callback : null;

			// Error
			this.btn_error = options.btn_error;
			this.btn_error_delay = options.btn_error_delay ? options.btn_error_delay : 1500;
			this.btn_error_label = options.btn_error_label ? options.btn_error_label : "";
			this.btn_error_cancel_label = options.btn_error_cancel_label ? options.btn_error_cancel_label : "Cancel";
			this.btn_error_message = options.btn_error_message ? options.btn_error_message : "";
			this.btn_error_callback = options.btn_error_callback ? options.btn_error_callback : null;

			// Internal Configurations
			this.is_btn_component = true;
			this.is_confirmed = false;
			this.is_error_cancel = false;
			this.is_processing = false;
			this.action_alert_html = null;

			BaseView.prototype.initialize(this);
		},

		render: function () {
			var that = this;

			this.$el.html(this.template());

			switch (this.alert_type) {
				case 0:
					this.showStandardAlert();
					break;
				case 1:
					this.showActionAlert();
					break;
				case 2:
					this.showActionAlert({ icon: true });
					break;
				default:
					this.showStandardAlert();
					break;
			}

			setTimeout(function () {
				that.$el.find(".js-alert-cancel").on("click", function () {
					that.cancelProcessMODAL();
				});
			}, 700);

			return this;
		},

		loadData: function () {
			this.parent_view = this.calling_view.calling_view;
		},

		showStandardAlert: function () {},

		showActionAlert: function (options) {
			this.action_alert_html = new ActionAlertView({
				elementName: ".js-alert-modal-content-container",
				data: this,
				opt: options,
			});
		},

		startProcessMODAL: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}

			// Do not proceed if process is still active
			if (this.calling_view.is_processing) {
				console.log("Still Processing, do nothing");
				return false;
			}

			var that = this,
				button = $(e.currentTarget),
				confirming = button.hasClass("confirming"),
				success = button.hasClass("success"),
				error = button.hasClass("error");

			// If confirmation necessary
			if (this.calling_view.btn_confirm) {
				// console.log('startProcessMODAL confirm',confirming,success,error,this.calling_view.is_confirmed,this.calling_view);

				// If user has not confirmed and the button is not in a confirm state
				if (!this.calling_view.is_confirmed && !confirming) {
					// Do not allow financial transaction to go further if the transaction amount is 0
					if (this.calling_view.is_transaction && this.calling_view.btn_confirm_amount == 0) {
						if (_.isFunction(this.calling_view.transaction_callback)) {
							if (this.calling_view.transaction_callback.name) {
								this.calling_view.calling_view[this.calling_view.transaction_callback.name]();
							} else {
								this.calling_view.transaction_callback(this.calling_view.calling_view);
							}
						}

						return false;
					}

					var confirm_label = this.calling_view.btn_confirm ? this.calling_view.btn_confirm_label : "",
						confirm_amount =
							this.calling_view.btn_confirm_amount > 0
								? formatBalanceCurrency(this.calling_view.btn_confirm_amount)
								: "",
						confirm_html = confirm_amount != "" ? confirm_label + " " + confirm_amount : confirm_label;

					// Change button
					this.$(".js-alert-acknowledge-btn").addClass("btn--green confirming");
					this.$(".js-alert-acknowledge-btn").html(confirm_html);

					// if(_.isFunction(this.btn_callback)){

					//     this.calling_view.calling_view[this.btn_callback.name]();

					// }
				} else if (confirming) {
					// If the button is in the confirm state and the user "confirms"

					// Change the button to processing
					this.calling_view.changeToProcessingStateMODAL();

					// Hide the cancel button when processing
					this.calling_view.hideCancelButtonMODAL();

					// Update internal confirmation status
					this.calling_view.is_confirmed = true;

					// Notify calling view that user has confirmed
					if (_.isFunction(this.calling_view.btn_confirm_callback)) {
						if (this.calling_view.btn_confirm_callback.name) {
							this.calling_view.calling_view[this.calling_view.btn_confirm_callback.name](
								this.calling_view.processComplete
							);
						} else {
							this.calling_view.btn_confirm_callback(
								this.calling_view.processComplete,
								this.calling_view.calling_view
							);
						}
					}
				} else {
					if (success) {
						if (_.isFunction(this.calling_view.btn_success_callback)) {
							if (this.calling_view.btn_success_callback.name) {
								this.calling_view.calling_view[this.calling_view.btn_success_callback.name](
									this.calling_view.resetButtonState
								);
							} else {
								this.calling_view.btn_success_callback(
									this.calling_view.resetButtonState,
									this.calling_view.calling_view
								);
							}
						}
					}

					if (error) {
						// Assuming re-try
						this.calling_view.changeToProcessingStateMODAL();

						// Hide the cancel button when processing
						this.calling_view.hideCancelButtonMODAL();

						// Reset this for retry
						this.calling_view.is_confirmed = false;

						if (_.isFunction(this.calling_view.btn_confirm_callback)) {
							if (this.calling_view.btn_confirm_callback.name) {
								this.calling_view.calling_view[this.calling_view.btn_confirm_callback.name](
									this.calling_view.processComplete
								);
							} else {
								this.calling_view.btn_confirm_callback(
									this.calling_view.processComplete,
									this.calling_view.calling_view
								);
							}
						}
					}
				}
			} else {
				// console.log('startProcessMODAL',this, this.parent_view,this.calling_view,this.calling_view.calling_view);

				// console.log('startProcessMODAL ELSE',confirming,success,error,this.calling_view.is_confirmed,this.calling_view);

				if (success) {
					if (this.calling_view.btn_success && _.isFunction(this.calling_view.btn_success_callback)) {
						if (
							_.isObject(this.calling_view.calling_view) &&
							_.isFunction(this.calling_view.calling_view[this.calling_view.btn_success_callback.name])
						) {
							this.calling_view.calling_view[this.calling_view.btn_success_callback.name](
								this.calling_view.resetButtonState
							);
						} else if (_.isFunction(this.calling_view.btn_success_callback)) {
							this.calling_view.btn_success_callback(this.calling_view.resetButtonState);
						} else {
							this.calling_view.btn_success_callback(
								this.calling_view.resetButtonState,
								this.calling_view.calling_view
							);
						}
					}

					this.$el.fadeOut(function () {
						that.$el.remove();
					});
				} else if (error) {
					// Assuming re-try
					this.calling_view.changeToProcessingStateMODAL();

					// Hide the cancel button when processing
					this.calling_view.hideCancelButtonMODAL();

					// Reset this for retry
					this.calling_view.is_confirmed = false;

					if (_.isFunction(this.calling_view.btn_retry_callback)) {
						if (this.calling_view.btn_retry_callback.name) {
							this.calling_view.calling_view[this.calling_view.btn_retry_callback.name](
								this.calling_view.processComplete
							);
						} else {
							this.calling_view.btn_retry_callback(
								this.calling_view.processComplete,
								this.calling_view.calling_view
							);
						}
					}
				} else {
					// If no confirmation is needed, use the default button callback
					// TODO: Give option of success/error feedback
					if (_.isFunction(this.calling_view.btn_callback)) {
						if (
							this.calling_view.btn_success ||
							this.calling_view.btn_confirm ||
							this.calling_view.btn_cancel ||
							this.calling_view.btn_error
						) {
							this.calling_view.changeToProcessingStateMODAL();
						}

						if (this.calling_view.btn_callback.name) {
							this.calling_view.calling_view[this.calling_view.btn_callback.name](
								this.calling_view.processComplete
							);
						} else {
							this.calling_view.btn_callback(this.calling_view.processComplete, this.calling_view.calling_view);
						}
					}
				}
			}
		},

		processComplete: function (success, that) {
			var that = that ? that : this,
				save_button = $(".js-alert-acknowledge-btn");

			if (success) {
				if (that.btn_color) {
					save_button.removeClass(that.btn_color);
				}

				save_button.addClass("circle");
				save_button.addClass("btn--green");
				save_button.removeClass("processing");
				save_button.html(enums.svg.checkIcon);

				if (that.btn_success) {
					setTimeout(function () {
						that.showProcessSuccessMODAL();
						that.is_processing = false;
					}, that.btn_success_delay);
				}
			} else {
				save_button.addClass("btn--red");
				save_button.addClass("circle");
				save_button.removeClass("btn--green");
				save_button.removeClass("processing");
				save_button.html(enums.svg.closeBtnIcon);

				that.is_error_cancel = true;

				if (that.btn_error) {
					setTimeout(function () {
						that.showProcessErrorMODAL();
						that.is_processing = false;
					}, that.btn_error_delay);
				}
			}
		},

		showProcessSuccessMODAL: function () {
			var save_button = $(".js-alert-acknowledge-btn"),
				feedback = $(".js-alert-process-complete-feedback");

			// console.log('showProcessSuccessMODAL',this);

			feedback.html('<span><img src="img/icons/icon-check-green.png" />' + this.btn_success_message + "</span>");
			feedback.addClass("success");
			feedback.fadeIn();

			save_button.removeClass("processing");
			save_button.removeClass("circle");
			save_button.addClass("btn--green");
			save_button.addClass("success");
			save_button.html(this.btn_success_label);
		},

		showProcessErrorMODAL: function () {
			var save_button = $(".js-alert-acknowledge-btn"),
				cancel_button = $(".js-alert-cancel"),
				feedback = $(".js-alert-process-complete-feedback");

			feedback.html('<span><img src="img/icons/icon-close-red.png" />' + this.btn_error_message + "</span>");
			feedback.addClass("error");
			feedback.fadeIn();

			save_button.removeClass("processing");
			save_button.removeClass("circle");
			save_button.addClass("btn--red");
			save_button.addClass("error");
			save_button.html(this.btn_error_label);

			if (this.btn_cancel) {
				cancel_button.html(this.btn_error_cancel_label);
				cancel_button.show();
			}
		},

		hideCancelButtonMODAL: function () {
			$(".js-alert-cancel").hide();
		},

		changeToProcessingStateMODAL: function () {
			var save_button = $(".js-alert-acknowledge-btn"),
				cancel_button = $(".js-alert-cancel"),
				feedback = $(".js-alert-process-complete-feedback");

			feedback.fadeOut();
			feedback.removeClass("success");
			feedback.removeClass("error");
			feedback.html("");

			if (this.btn_color) {
				save_button.removeClass(this.btn_color);
			}
			save_button.removeClass("error");
			save_button.removeClass("success");
			save_button.removeClass("confirming");
			save_button.removeClass("btn--red");

			if (this.btn_confirm) {
				save_button.addClass("btn--green");
			}

			if (this.btn_cancel) {
				cancel_button.hide();
			}

			save_button.addClass("processing");
			save_button.html(enums.svg.spinnerDarkBlueIcon);

			this.is_error_cancel = false;
			this.is_processing = true;
		},

		showProcessingState: function (intent) {
			if (!intent) {
				this.btn_success = false;
				this.btn_cancel = false;
				this.btn_confirm = false;
				this.btn_error = false;
			} else {
			}
		},

		updateBtnLabel: function (label) {
			this.btn_label = label;
			this.$(".js-alert-acknowledge-btn").html(this.btn_label);
		},

		updateBtnLabelColor: function (color) {
			this.btn_color = color;
			this.$(".js-alert-acknowledge-btn").removeClass("red");
			this.$(".js-alert-acknowledge-btn").addClass(this.btn_color);
		},

		updateBtnCallback: function (callback) {
			this.btn_callback = callback;
		},

		updateBtnRetryCallback: function (callback) {
			this.btn_retry_callback = callback;
		},

		updateAlertHeader: function (text) {
			this.alert_header = text;
			this.action_alert_html.updateDataMODAL(this);
		},

		updateAlertMessage: function (text) {
			this.alert_message = text;
			this.action_alert_html.updateDataMODAL(this);
		},

		updateErrorMessage: function (text) {
			this.btn_error_message = text;
		},

		updateErrorModalMessage: function (text) {
			this.btn_error_modal_message = text;
		},

		updateSuccessModalMessage: function (text) {
			this.btn_success_modal_message = text;
		},

		updateCofirmAmount: function (num) {
			this.btn_confirm_amount = Number(num);
		},

		resetButtonState: function (that) {
			var that = that ? that : this,
				save_button = $(".js-alert-acknowledge-btn"),
				cancel_button = $(".js-alert-cancel"),
				feedback = $(".js-alert-process-complete-feedback");

			feedback.fadeOut();
			feedback.removeClass("success");
			feedback.removeClass("error");
			feedback.html("");

			save_button.removeClass("error");
			save_button.removeClass("processing");
			save_button.removeClass("success");
			save_button.removeClass("confirming");
			save_button.removeClass("btn--red");
			save_button.removeClass("btn--green");
			save_button.html(that.btn_label);

			if (that.btn_color == "red") {
				save_button.addClass("btn--red");
			}

			that.is_confirmed = false;
			that.is_error_cancel = false;
			that.is_processing = false;

			if (that.btn_cancel) {
				cancel_button.html(that.btn_cancel_label);
				cancel_button.show();
			}

			if (that.calling_view.alert_modal) {
				if (_.isFunction(that.calling_view.alert_modal)) {
					that.calling_view.alert_modal.closeModal();
				}
			}
		},

		cancelProcessMODAL: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}

			var view = this.calling_view,
				modal = this.calling_view.calling_view;

			view.is_confirmed = false;

			view.resetButtonState();

			if (_.isFunction(view.btn_cancel_callback) && !view.is_error_cancel) {
				if (view.btn_cancel_callback.name) {
					modal[view.btn_cancel_callback.name]();
				} else {
					view.btn_cancel_callback(modal);
				}
			} else if (_.isFunction(view.btn_error_callback) && view.is_error_cancel) {
				if (view.btn_error_callback.name) {
					modal[view.btn_error_callback.name]();
				} else {
					view.btn_error_callback(modal);
				}
			}
		},

		close: function () {},
	});
});

